import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { LoaderService } from '@dss-libs/shared/utility/common-services';

@Component({
  selector: 'dss-libs-ui-spinner',
  imports: [AsyncPipe],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  loaderService = inject(LoaderService);
}
